/**
 * AuthServiceStandalone — single-user, no auth required.
 *
 * Standalone host has no tenant/user model. isAuthenticated returns
 * true so downstream code that gates on it (e.g., campaign-picker
 * mount) doesn't paint a login screen. getTenantId/getUserId return
 * null — the UI handles null with a "single-player" code path.
 *
 * No M4 work changes this — standalone is permanently auth-less.
 */
import type { AuthService } from '../types';

export class AuthServiceStandalone implements AuthService {
  isAuthenticated(): boolean {
    return true;
  }

  getTenantId(): string | null {
    return null;
  }

  getUserId(): string | null {
    return null;
  }
}
